import { Injectable } from "@angular/core";

import { User } from "@impulse/sdp-shared-models";
import { safePromiseAll } from "@impulse/sdp-promises";

import { ApiGatewayService } from "../common/api-gateway/api-gateway.service";
import { SessionView, SessionStatus, Session, SessionViewPartial } from "./models";
import { GatewaysService } from "../administrative/gateways";


@Injectable()
export class SessionsService {
	constructor(
		private apiGatewayService: ApiGatewayService,
		private gatewayService: GatewaysService
	) { }

	public async getSessions(status: SessionStatus) {
		const [sessions, users, gateways] = await safePromiseAll([
			this.apiGatewayService.getSessions(status),
			this.apiGatewayService.getAllUsers(),
			this.gatewayService.getGateways()
		]);
		const primaryUser = users.find((user) => user.primary);
		if (!primaryUser) {
			throw new Error("failed to look up account owner");
		}
		return sessions.map<SessionView>((session) => {
			let gatewayName: string;
			if (session.gatewayType === "cloud") {
				gatewayName = "Cloud Gateway";
			} else if (session.gatewayType === "private") {
				const gateway = gateways.privateGateways.find((g) => {
					return g.uuid === session.gatewayUuid;
				});
				if (!!gateway) {
					gatewayName = gateway.label;
				} else {
					gatewayName = "Gateway Removed";
				}
			} else {
				gatewayName = "N/A";
			}
			return Object.assign<SessionViewPartial, Session>(
				{
					gatewayName: gatewayName,
					isPrimaryUser: session.userType === "cognito" && session.userName === primaryUser.email
				},
				session
			);
		});
	}

	public async disableCognitoUser(userName: User.Name) {
		await this.apiGatewayService.updateUser(
			{
				disabled: true
			},
			userName
		);
	}

	public async disconnectSessions(userName: Session.UserName, userType?: Session.UserType) {
		await this.apiGatewayService.disconnectSessions({
			userName: userName,
			userType: userType
		});
	}

	public async disconnectSession(sessionUuid: Session.SessionUuid) {
		await this.apiGatewayService.disconnectSessions({
			sessionUuid: sessionUuid
		});
	}
}
